import styled from 'styled-components'

const HeroStyle = styled.div`
	--heroImagePaddingTop: var(--sp163x);
	--heroContentPadding: var(--sp18x) var(--sp8x) var(--sp9x);
	--heroBtnPadding: var(--sp2x) var(--sp5x);
	--firstButtonMarginRight: var(--sp3x);
	--titleMarginTop: var(--sp5x);
	--btnBorderRadius: var(--sp1-5x);
	--heroBtnIconSize: var(--sp3x);
	--heroBtnMarginLeft: var(--sp1-5x);
	--heroSubtitleMaxWidth: var(--sp200x);

	position: relative;

	.hero-image {
		position: absolute !important;
		top: 0;
		left: 0;
		width: 100%;
		padding-top: var(--heroImagePaddingTop);
	}

	.layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: var(--bgLayer);
		z-index: 1;

		&:after {
			content: '';
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			height: 100%;
			background: var(--bgLayer);
			z-index: 1;
			transform: rotate(180deg);
		}
	}

	.hero-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		height: var(--heroImagePaddingTop);
		padding: var(--heroContentPadding);
		z-index: 1;

		.path-wrap,
		.title,
		.hero-btns-wrap,
		.subtitle {
			transform: translateY(100%);
		}

		.title {
			margin-top: var(--titleMarginTop);
		}

		.hero-footer {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;

			.hero-btns-wrap {
				display: flex;

				.hero-btn {
					&:first-child {
						margin-right: var(--firstButtonMarginRight);
					}
				}
			}

			.subtitle {
				text-align: right;
				max-width: var(--heroSubtitleMaxWidth);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--heroContentPadding: var(--sp14x) var(--sp6x) var(--sp7x);
		--btnBorderRadius: var(--sp1-5x);
		--heroImagePaddingTop: var(--sp121x);
		--heroBtnPadding: var(--sp2x) var(--sp4x);
		--firstButtonMarginRight: var(--sp3x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1-5x);
		--heroSubtitleMaxWidth: var(--sp160x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--heroContentPadding: var(--sp12x) var(--sp5x) var(--sp6x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp108x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp128x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--heroContentPadding: var(--sp12x) var(--sp5x) var(--sp6x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp94x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp128x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--heroContentPadding: var(--sp10x) var(--sp4x) var(--sp5x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp95x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp106x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--heroContentPadding: var(--sp10x) var(--sp4x) var(--sp5x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp95x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp88x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--heroContentPadding: var(--sp9x) var(--sp3x) var(--sp4x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp95x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp75x);

		.hero-footer {
			flex-direction: column-reverse;

			.hero-btns-wrap {
				align-self: flex-start;
				margin-top: var(--sp4x);
			}
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--heroContentPadding: var(--sp9x) var(--sp3x) var(--sp4x);
		--btnBorderRadius: var(--sp1x);
		--heroImagePaddingTop: var(--sp78x);
		--heroBtnPadding: var(--sp1-5x) var(--sp3x);
		--firstButtonMarginRight: var(--sp2x);
		--titleMarginTop: var(--sp3x);
		--heroBtnIconSize: var(--sp2x);
		--heroBtnMarginLeft: var(--sp1x);
		--heroSubtitleMaxWidth: var(--sp45x);

		.hero-footer {
			flex-direction: column-reverse;

			.hero-btns-wrap {
				align-self: flex-start;
				margin-top: var(--sp4x);
			}
		}
	}
`

export default HeroStyle
